import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { AnomalyTypeAPI, Nullable } from '@shared';
import { useFormik } from 'formik';

type PropsType = {
  anomalyTypes: Nullable<AnomalyTypeAPI[]>;
  id: number;
} & Pick<ReturnType<typeof useFormik>, 'handleChange'>;

export function SelectAnomaly({ anomalyTypes, id, handleChange }: PropsType) {
  return (
    <FormControl size='small' fullWidth>
      <InputLabel>Anomaly type</InputLabel>
      <Select value={id} name='id' label='Anomaly Type' onChange={handleChange}>
        {anomalyTypes?.map((anomalyType) => (
          <MenuItem value={anomalyType.id} key={anomalyType.id}>
            {anomalyType.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
